export default function ValidIcon({
  color = '#368a2a',
  width = 10,
  height = 10,
  style = {},
}) {
  return (
    <svg
      height={height}
      width={width}
      style={{ ...style }}
      viewBox="0 0 97.72 97.72"
      >
      <path style={{ fill: color }} d="M41,69.88a2.4,2.4,0,0,0,.64-.47L76.15,34.87a2.52,2.52,0,0,0,0-3.55l-1.78-1.77a2.5,2.5,0,0,0-3.54,0l-31,31L26.1,46.83a2.51,2.51,0,0,0-3.55,0L20.78,48.6a2.51,2.51,0,0,0,0,3.55L38.05,69.41A2.51,2.51,0,0,0,41,69.88Zm-41-21A48.86,48.86,0,1,1,48.86,97.72,48.86,48.86,0,0,1,0,48.86Z" />
    </svg>
  );
}
